import { Action, Reducer } from 'redux'
import {
  IModalsState,
  ISpotBiddingRule,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'
import {
  ADD_SPOT_BIDDING_RULE_MODAL,
  CREATE_SPOT_BIDDING_RULE_ACTION_TYPES,
  DELETE_SPOT_BIDDING_RULE_ACTION_TYPES,
  DELETE_SPOT_BIDDING_RULE_MODAL,
  UPDATE_SPOT_BIDDING_RULE_ACTION_TYPES,
} from 'apps/spot-quote-control-panel/utils/actions/spotBiddingConfig'

const {
  ADD_SPOT_BIDDING_RULE_MODAL_CLOSE,
  ADD_SPOT_BIDDING_RULE_MODAL_OPEN,
} = ADD_SPOT_BIDDING_RULE_MODAL

const {
  DELETE_SPOT_BIDDING_RULE_MODAL_CLOSE,
  DELETE_SPOT_BIDDING_RULE_MODAL_OPEN,
} = DELETE_SPOT_BIDDING_RULE_MODAL

const {
  CREATE_SPOT_BIDDING_RULE_FAILURE,
  CREATE_SPOT_BIDDING_RULE_REQUEST,
  CREATE_SPOT_BIDDING_RULE_SUCCESS,
} = CREATE_SPOT_BIDDING_RULE_ACTION_TYPES

const {
  UPDATE_SPOT_BIDDING_RULE_FAILURE,
  UPDATE_SPOT_BIDDING_RULE_REQUEST,
  UPDATE_SPOT_BIDDING_RULE_SUCCESS,
} = UPDATE_SPOT_BIDDING_RULE_ACTION_TYPES

const {
  DELETE_SPOT_BIDDING_RULE_FAILURE,
  DELETE_SPOT_BIDDING_RULE_REQUEST,
  DELETE_SPOT_BIDDING_RULE_SUCCESS,
} = DELETE_SPOT_BIDDING_RULE_ACTION_TYPES

interface IRuleModalAction extends Action<string> {
  payload?: {
    rule?: ISpotBiddingRule
  }
}

interface IErrorAction extends Action<string> {
  error: string
}

type ModalsAction = IRuleModalAction | IErrorAction

const defaultState: IModalsState = {
  showAddModal: false,
  showDeleteModal: false,
  inProgress: false,
}

const modalsReducer: Reducer<IModalsState, ModalsAction> = (state = defaultState, action) => {
  switch (action.type) {
    case ADD_SPOT_BIDDING_RULE_MODAL_OPEN: {
      return {
        ...state,
        showAddModal: true,
        modalPayload: (action as IRuleModalAction).payload,
      }
    }
    case ADD_SPOT_BIDDING_RULE_MODAL_CLOSE: {
      return {
        ...state,
        showAddModal: false,
        error: undefined,
      }
    }
    case DELETE_SPOT_BIDDING_RULE_MODAL_OPEN: {
      return {
        ...state,
        showDeleteModal: true,
        modalPayload: (action as IRuleModalAction).payload,
      }
    }
    case DELETE_SPOT_BIDDING_RULE_MODAL_CLOSE: {
      return {
        ...state,
        showDeleteModal: false,
      }
    }
    case CREATE_SPOT_BIDDING_RULE_REQUEST: {
      return {
        ...state,
        inProgress: true,
        error: undefined,
      }
    }
    case CREATE_SPOT_BIDDING_RULE_SUCCESS: {
      return {
        ...state,
        inProgress: false,
        showAddModal: false,
        error: undefined,
      }
    }
    case CREATE_SPOT_BIDDING_RULE_FAILURE: {
      return {
        ...state,
        inProgress: false,
        error: (action as IErrorAction).error,
      }
    }
    case UPDATE_SPOT_BIDDING_RULE_REQUEST: {
      return {
        ...state,
        inProgress: true,
        error: undefined,
      }
    }
    case UPDATE_SPOT_BIDDING_RULE_SUCCESS: {
      return {
        ...state,
        inProgress: false,
        showAddModal: false,
        error: undefined,
      }
    }
    case UPDATE_SPOT_BIDDING_RULE_FAILURE: {
      return {
        ...state,
        inProgress: false,
        error: (action as IErrorAction).error,
      }
    }
    case DELETE_SPOT_BIDDING_RULE_REQUEST: {
      return {
        ...state,
        inProgress: true,
        error: undefined,
      }
    }
    case DELETE_SPOT_BIDDING_RULE_SUCCESS: {
      return {
        ...state,
        inProgress: false,
        showDeleteModal: false,
        error: undefined,
      }
    }
    case DELETE_SPOT_BIDDING_RULE_FAILURE: {
      return {
        ...state,
        inProgress: false,
        error: (action as IErrorAction).error,
      }
    }

    default:
      return state
  }
}

export default modalsReducer
